module.exports = __webpack_public_path__ + "static/media/dubai-fest-city.c5494b7c.avif";